import { streamGroq, GroqMissingKeyError } from './groq-client';

export async function aiRateInsight(skill: string, seniority: string, location: string, yourRate: number, marketP25: number, marketMedian: number, marketP75: number, onStream: (chunk: string) => void): Promise<void> {
  const system = `You are a consulting-business coach. Given a solo consultant's current rate vs market band, deliver: 1) blunt assessment (under-charging, market-aligned, premium), 2) 3 concrete tactics to defend a higher rate, 3) one risk to watch. Be specific, actionable, under 200 words. Markdown.`;
  try {
    await streamGroq({
      messages: [{ role: 'system', content: system }, { role: 'user', content: `Skill: ${skill}\nSeniority: ${seniority}\nLocation: ${location}\nYour rate: $${yourRate}/hr\nMarket P25: $${marketP25}\nMarket Median: $${marketMedian}\nMarket P75: $${marketP75}` }],
      temperature: 0.4, onStream,
    });
  } catch (err) {
    if (err instanceof GroqMissingKeyError) { onStream('\n\n⚠️ No Groq API key set. Click the Settings gear ⚙ in the header to paste your free key.'); return; }
    onStream(`\n\n⚠️ ${err instanceof Error ? err.message : 'Groq error'}`);
  }
}
